import { isInvalidTokenMessage, notifyInvalidTokenAndLogout } from '../utils';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8082/api/v1';

const extractResponseMessage = (text: string): string => {
  if (!text) {
    return '';
  }

  try {
    const parsed = JSON.parse(text);
    return typeof parsed?.message === 'string' ? parsed.message : text;
  } catch {
    return text;
  }
};

export async function apiFetch(url: string, options: RequestInit = {}, ignoreAuth = false) {
  const token = localStorage.getItem('accessToken');
  const headers = new Headers(options.headers);
  if (!ignoreAuth && token) {
    headers.set('Authorization', 'Bearer ' + token);
  }

    const res = await fetch(API_BASE + url, { ...options, headers });
    const text = res.status === 204 || res.status === 205 ? '' : await res.text();

    if (!res.ok) {
      const message = extractResponseMessage(text) || 'API error: ' + res.status;
      if (!ignoreAuth && isInvalidTokenMessage(message)) {
        notifyInvalidTokenAndLogout();
        return await new Promise<never>(() => {});
      }
      throw new Error(message);
    }

    return text ? JSON.parse(text) : undefined;
  }

export async function apiFetchBlob(url: string, options: RequestInit = {}, ignoreAuth = false): Promise<Blob> {
  const token = localStorage.getItem('accessToken');
  const headers = new Headers(options.headers);
  if (!ignoreAuth && token) {
    headers.set('Authorization', 'Bearer ' + token);
  }

  const res = await fetch(API_BASE + url, { ...options, headers });
  if (!res.ok) {
    const message = extractResponseMessage(await res.text()) || 'API error: ' + res.status;
    if (!ignoreAuth && isInvalidTokenMessage(message)) {
      notifyInvalidTokenAndLogout();
      return await new Promise<never>(() => {});
    }
    throw new Error(message);
  }
  return res.blob();
}
